class SplideMobileSlider {
  constructor(containerSelector, breakpoint = 768) {
    this.containerSelector = containerSelector;
    this.breakpoint = breakpoint;
    this.sliders = [];
    this.observer = null;
    this.sliderObservers = new Map(); // To keep track of slider-specific observers
    this.init();
    window.addEventListener('resize', () => this.handleResize());
  }

  init() {
    if (window.innerWidth <= this.breakpoint) {
      this.setupLazyLoading();
    } else {
      this.destroySliders();
    }
  }

  handleResize() {
    if (window.innerWidth <= this.breakpoint) {
      if (!this.observer) this.setupLazyLoading();
    } else {
      this.destroySliders();
    }
  }

  setupLazyLoading() {
    const containers = document.querySelectorAll(this.containerSelector);
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.setupSlider(entry.target);
            observer.unobserve(entry.target);
          }
        });
      });

      containers.forEach((container) => this.observer.observe(container));
    } else {
      // Fallback: Initialize all sliders immediately
      containers.forEach((container) => this.setupSlider(container));
    }
  }

  setupSlider(container) {
    const columnsWrapper = container.querySelector('.voyager-columns__wrapper');
    if (!columnsWrapper) return;

    const images = columnsWrapper.querySelectorAll('img');
    const sliderContainer = this.createSliderContainer();
    const sliderTrack = this.createSliderTrack();
    const sliderList = this.createSliderList();

    sliderTrack.appendChild(sliderList);
    sliderContainer.appendChild(sliderTrack);

    images.forEach((img, index) => {
      const listItem = this.createSlideItem(img, index, images.length);
      sliderList.appendChild(listItem);
    });

    container.appendChild(sliderContainer);
    this.initializeSplide(sliderContainer);
  }

  destroySliders() {
    this.sliders.forEach((slider) => slider.destroy());
    this.sliders = [];
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    document.querySelectorAll('.voyager-columns__mobile-carousel').forEach((el) => el.remove());

    // Disconnect and clear all slider-specific observers
    this.sliderObservers.forEach((observer) => observer.disconnect());
    this.sliderObservers.clear();
  }

  createSliderContainer() {
    const sliderContainer = document.createElement('div');
    sliderContainer.classList.add('splide', 'voyager-columns__mobile-carousel');
    sliderContainer.id = `splide-slider-${this.sliders.length}`;
    return sliderContainer;
  }

  createSliderTrack() {
    const sliderTrack = document.createElement('div');
    sliderTrack.classList.add('splide__track');
    return sliderTrack;
  }

  createSliderList() {
    const sliderList = document.createElement('ul');
    sliderList.classList.add('splide__list');
    return sliderList;
  }

  createSlideItem(img, index, total) {
    const listItem = document.createElement('li');
    listItem.classList.add('splide__slide');
    listItem.setAttribute('role', 'group');
    listItem.setAttribute('aria-roledescription', 'slide');
    listItem.setAttribute('aria-label', `${index + 1} of ${total}`);

    const imgClone = img.cloneNode(true);
    imgClone.removeAttribute('id');
    imgClone.setAttribute('loading', 'lazy');
    listItem.appendChild(imgClone);

    return listItem;
  }

  initializeSplide(container) {
    const slider = new Splide(`#${container.id}`, {
      type: 'slide',
      perPage: 1,
      autoplay: false, // Start with autoplay disabled
    }).mount();

    this.sliders.push(slider);

    // Create an IntersectionObserver for this slider
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          slider.options = { ...slider.options, autoplay: true }; // Enable autoplay
          slider.Components.Autoplay.play(); // Start autoplay
        } else {
          slider.Components.Autoplay.pause(); // Pause autoplay
        }
      });
    });

    observer.observe(container);
    this.sliderObservers.set(slider, observer);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  new SplideMobileSlider('.voyager-columns__container');
});
